import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Tree, Input, Row, Col, Typography, Form, Button, InputNumber, Upload, Icon, Switch, notification, Modal, Collapse } from 'antd';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import Format from '../../utils/format';
import DateFnsUtils from '@date-io/date-fns';
import MainContainer from '../../components/MainContainer';
import Toast from 'antd-mobile/lib/toast';
import ClearIcon from '@material-ui/icons/Clear';
import { red } from '@material-ui/core/colors';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { green } from '@material-ui/core/colors';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ApiCaller from '../../utils/api-caller';
import { withTranslation } from 'react-i18next';
import adminI18n from '../i18n/adminI18n';

const { TreeNode } = Tree;
const { Search } = Input;
const { Title } = Typography;
const { Panel } = Collapse;

const REACT_APP_IS_USING_SHIJI_API = process.env.REACT_APP_IS_USING_SHIJI_API;

@inject(
  'loginStore',
  'CmsLanguageStore',
  'CmsTaskStore')
@observer
class CmsTask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
      autoExpandParent: true,
      uploadingIconImage: false
    }
  }

  componentDidMount() {
    this.props.loginStore.authenticateAdmin().then(response => {
      if (!response) {
        this.props.history.push('/admin/login');
      }
    });

    this.props.CmsTaskStore.settaskTreeLoading(true);
    this.props.CmsLanguageStore.getActives().then(() => {
      this.props.CmsTaskStore.getShorts().then(() => {
        this.props.CmsTaskStore.getTreeTasks().then(() => {
          this.props.CmsTaskStore.setselectedTaskTree(['StayMenu']);
          this.props.CmsTaskStore.setexpandedTaskTree(['StayMenu']);

          const {
            selectedTaskTree
          } = this.props.CmsTaskStore;

          const taskName = selectedTaskTree[0];

          this.props.CmsTaskStore.getByTaskName(taskName);
        });
      });
    });
  }

  searchTaskNameKeyDown = (e) => {
    if (e.keyCode === 13) {
      if (this.state.searchValue === '') {
        this.props.CmsTaskStore.setselectedTaskTree(['StayMenu']);
      }

      const {
        taskTreeData,
        taskTreeList
      } = this.props.CmsTaskStore;

      const expandedKeys = taskTreeList
        .map(item => {
          if (item.title.toUpperCase().indexOf(this.state.searchValue.toUpperCase()) > -1) {
            return this.props.CmsTaskStore.getTaskParentKey(item.key, taskTreeData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);

      this.props.CmsTaskStore.setexpandedTaskTree(expandedKeys);

      this.setState({
        searchValue: this.state.searchValue,
        autoExpandParent: true,
      });

      if (this.state.searchValue === '') {
        this.props.CmsTaskStore.setexpandedTaskTree(['StayMenu']);
      }
    }
  }

  searchTaskNameChanged = (e) => {
    this.setState({
      searchValue: e.target.value
    });
  }

  taskExpanded = expandedKeys => {
    this.props.CmsTaskStore.setexpandedTaskTree(expandedKeys)
    this.setState({
      autoExpandParent: false,
    })
  }

  taskSelected = (taskNames) => {
    const taskName = taskNames[0];
    if (taskName) {
      this.props.CmsTaskStore.settaskTreeLoading(true);
      this.props.CmsTaskStore.setselectedTaskTree([taskName]);
      this.props.CmsTaskStore.getByTaskName(taskName);
    }
  }

  // UPLOAD Settings

  dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok')
    }, 0);
  }

  beforeUploadIconImage = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
    if (!isJpgOrPng) {
      notification.warning({
        message: this.props.t('Failed to upload image'),
        description: this.props.t('You can only upload JPG/PNG file!'),
        placement: 'bottomRight',
      });
    }

    const isLessThan10Mb = file.size / 1024 / 1024 <= 1;
    if (!isLessThan10Mb) {
      notification.warning({
        message: this.props.t('Failed to upload image'),
        description: this.props.t('Image must smaller or equal to 1MB!'),
        placement: 'bottomRight',
      });
    }

    if (isJpgOrPng && isLessThan10Mb) {
      this.setState({ uploadingIconImage: true });
    }

    return isJpgOrPng && isLessThan10Mb;
  }

  uploadChangeIconImage = (info, title) => {
    if (info.file.status) {
      if (info.file.status === 'uploading') {
        this.props.CmsTaskStore.setimageUrl('');
        return;
      }
      if (info.file.status === 'done') {
        const category = 'CmsImage'
        const titleName = Format.RemoveSpecialChars(title) || 'Default'

        return ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(resp => {
          this.props.CmsTaskStore.setimageUrl(resp.imageUrl);
          this.setState({ uploadingIconImage: false });
        });
      }
    }
  }

  create = () => {
    this.props.CmsTaskStore.settaskTreeLoading(true);
    this.props.CmsTaskStore.create().then(resp => {
      if (!resp.isError) {
        const {
          task
        } = this.props.CmsTaskStore;

        this.props.CmsLanguageStore.getActives().then(() => {
          this.props.CmsTaskStore.getShorts().then(() => {
            this.props.CmsTaskStore.getTreeTasks().then(() => {
              this.props.CmsTaskStore.setselectedTaskTree([task.taskName]);
              this.props.CmsTaskStore.getByTaskName(task.taskName);

              notification['success']({
                message: this.props.t('Success'),
                description: this.props.t('Task is successfully created.'),
                duration: 1
              });
            });
          });
        });
      } else {
        this.props.CmsTaskStore.settaskTreeLoading(false);
        notification['error']({
          message: this.props.t('Failed'),
          description: resp.error,
          duration: 5
        });
      }
    });
  }

  update = () => {
    this.props.CmsTaskStore.settaskTreeLoading(true);
    this.props.CmsTaskStore.update().then(resp => {
      if (!resp.isError) {
        const {
          task
        } = this.props.CmsTaskStore;

        this.props.CmsLanguageStore.getActives().then(() => {
          this.props.CmsTaskStore.getShorts().then(() => {
            this.props.CmsTaskStore.getTreeTasks().then(() => {
              this.props.CmsTaskStore.setselectedTaskTree([task.taskName]);
              this.props.CmsTaskStore.getByTaskName(task.taskName);

              notification['success']({
                message: this.props.t('Success'),
                description: this.props.t('Task is successfully updated.'),
                duration: 1
              });
            });
          });
        });
      } else {
        this.props.CmsTaskStore.settaskTreeLoading(false);
        notification['error']({
          message: this.props.t('Failed'),
          description: resp.error,
          duration: 5
        });
      }
    });
  }

  delete = () => {
    const {
      task
    } = this.props.CmsTaskStore;

    Modal.confirm({
      title: this.props.t('Delete Task'),
      content: `${this.props.t('Are you sure to delete')} "${task.taskName}"?`,
      okText: this.props.t('Yes'),
      cancelText: this.props.t('Cancel'),
      onOk: () => {
        this.props.CmsTaskStore.settaskTreeLoading(true);
        this.props.CmsTaskStore.delete().then((resp) => {
          if (resp.isError) {
            this.props.CmsTaskStore.settaskTreeLoading(false);
            notification['error']({
              message: this.props.t('Failed'),
              description: resp.error,
              duration: 5
            });
          } else {
            this.props.CmsLanguageStore.getActives().then(() => {
              this.props.CmsTaskStore.getShorts().then(() => {
                this.props.CmsTaskStore.getTreeTasks().then(() => {
                  this.props.CmsTaskStore.setselectedTaskTree([task.parentName]);
                  this.props.CmsTaskStore.getByTaskName(task.parentName);

                  notification['success']({
                    message: this.props.t('Success'),
                    description: this.props.t('Task is successfully deleted.'),
                    duration: 1
                  });
                });
              });
            });
          }
        });
      }
    })
  }

  isValidTaskName = () => {
    const {
      task
    } = this.props.CmsTaskStore;

    if (task) {
      return task.taskName && task.taskName !== '';
    }

    return false;
  }

  isValidTaskNameEnglish = () => {
    const {
      defaultLanguageId
    } = this.props.CmsLanguageStore;

    const {
      task
    } = this.props.CmsTaskStore;

    if (task) {
      const {
        taskLanguages
      } = task;

      if (taskLanguages) {
        const defaultTaskLanguage = taskLanguages.find(fi => fi.langID === defaultLanguageId);

        if (defaultTaskLanguage) {
          return defaultTaskLanguage.taskLangName !== '';
        }
      }
    }

    return false;
  }

  isValidPrice = () => {
    const {
      task
    } = this.props.CmsTaskStore;

    if (task) {
      return task.price !== null && task.price !== '';
    }

    return false;
  }

  isValidTotal = () => {
    const {
      task
    } = this.props.CmsTaskStore;

    if (task) {
      return task.total !== null && task.total !== '';
    }

    return false;
  }

  isValidMinimumStock = () => {
    const {
      task
    } = this.props.CmsTaskStore;

    if (task) {
      return task.minimumStock !== null && task.minimumStock !== '';
    }

    return false;
  }

  isValidSort = () => {
    const {
      task
    } = this.props.CmsTaskStore;

    if (task) {
      return task.sortID !== null && task.sortID !== '';
    }

    return false;
  }

  isValidRequestLimit = () => {
    const {
      task
    } = this.props.CmsTaskStore;

    if (task) {
      return task.requestLimit !== null && task.requestLimit !== '';
    }

    return false;
  }

  isValidDailyRequestLimit = () => {
    const {
      task
    } = this.props.CmsTaskStore;

    if (task) {
      return task.dailyRequestLimit !== null && task.dailyRequestLimit !== '';
    }

    return false;
  }

  syncFromInfrasysOnClick = () => {
    notification['success']({
      message: 'Success',
      description: 'Syncing with Infrasys is in progress. This may take a while, so please check the items regularly. Thank you.',
      duration: 3
    });

    ApiCaller.Shiji.apiSyncFnb().finally(() => {
      notification['success']({
        message: 'Success',
        description: 'Sync with Infrasys is complete. Thank you.',
        duration: 3
      });
    });
  }

  render() {
    const {
      searchValue,
      autoExpandParent
    } = this.state;

    const {
      activeLanguages,
      defaultLanguageId
    } = this.props.CmsLanguageStore;

    const {
      taskTreeLoading,
      taskTreeData,
      expandedTaskTree,
      selectedTaskTree,
      task
    } = this.props.CmsTaskStore;

    const { t } = this.props;

    const showEditButton = this.isValidTaskName() &&
      this.isValidTaskNameEnglish() &&
      this.isValidPrice() &&
      this.isValidTotal() &&
      this.isValidMinimumStock() &&
      this.isValidSort() &&
      this.isValidRequestLimit() &&
      this.isValidDailyRequestLimit();

    if (taskTreeLoading) {
      Toast.loading(t('Loading Data...'), 100, null, true);
    } else {
      Toast.hide();
    }

    const loop = data =>
      data.map(item => {
        const index = item.title.toUpperCase().indexOf(searchValue.toUpperCase())
        const beforeStr = item.title.substr(0, index)
        const searchValueStr = item.title.substr(index, searchValue.length)
        const afterStr = item.title.substr(index + searchValue.length)
        const title =
          index > -1 ? (
            (item.children ? (
              <span>
                {beforeStr}
                <span style={{ color: '#f50' }}>{searchValueStr}</span>
                {afterStr}
              </span>
            ) : (
              <React.Fragment>
                <span>
                  {beforeStr}
                  <span style={{ color: '#f50' }}>{searchValueStr}</span>
                  {afterStr}
                </span>
                <button style={{ border: 'none', background: 'none' }} onClick={this.createTaskClicked}>
                  <ClearIcon style={{ color: red[500], fontSize: 18 }} />
                </button>
              </React.Fragment>
            ))
          ) : (
            (item.children ? (
              <span>{item.title}</span>
            ) : (
              <React.Fragment>
                <span>{item.title}</span>
                <button style={{ border: 'none', background: 'none' }} onClick={this.createTaskClicked}>
                  <ClearIcon style={{ color: red[500], fontSize: 18 }} />
                </button>
              </React.Fragment>
            ))
          )
        if (item.children) {
          return (
            <TreeNode key={item.key} title={title}>
              {loop(item.children)}
            </TreeNode>
          )
        }
        return <TreeNode key={item.key} title={title} />
      });

    return (
      <MainContainer title={t('Task Management')} menukey="cms-task">
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Card
              style={{
                height: 700,
                padding: 20,
                overflow: 'auto'
              }}>
              <div>
                {
                  REACT_APP_IS_USING_SHIJI_API === 'true' ?
                    <Button onClick={this.syncFromInfrasysOnClick} style={{ backgroundColor: '#FAFAFA', marginBottom: '10px', width: '100%' }}>Sync from Infrasys</Button> :
                    <></>
                }
                <Search
                  style={{
                    marginBottom: 8
                  }}
                  placeholder={t('Search Task Name')}
                  onKeyDown={this.searchTaskNameKeyDown}
                  onChange={this.searchTaskNameChanged}
                />
                <div className='stm-font-size-12
                                stm-margin-bottom-8
                                stm-padding-right-16
                                stm-color-32323F
                                stm-text-align-right'>{t('Hit Enter to search')}</div>
                <Tree
                  onExpand={this.taskExpanded}
                  expandedKeys={expandedTaskTree}
                  autoExpandParent={autoExpandParent}
                  showLine={true}
                  onSelect={this.taskSelected}
                  selectedKeys={selectedTaskTree}
                >
                  {loop(taskTreeData)}
                </Tree>
              </div>
            </Card>
          </Grid>
          <Grid item xs={8}>
            <Card
              style={{
                height: 700,
                padding: 20,
                overflow: 'auto'
              }}>
              <>
                {
                  task
                    ?
                    <Form layout='horizontal'>
                      <div className='stm-min-height-52'>
                        <Title
                          level={3}
                          style={{ width: '80%', position: 'relative', float: 'left' }}>
                          {task.taskID !== 0 ? task.taskName : t('Create New Task')}
                        </Title>
                        <>
                          {
                            task.taskID !== 0 && task.nextCount > 0
                              ?
                              <div style={{ textAlign: 'right' }}>
                                <button
                                  style={{ border: 'none', background: 'none', cursor: 'pointer' }}
                                  onClick={() => this.props.CmsTaskStore.initCreate(task.taskID, task.taskName, task.taskLanguages)}>
                                  <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                                </button>
                              </div>
                              :
                              null
                          }
                        </>
                      </div>

                      <Collapse className='stm-margin-top-8' defaultActiveKey={[1, 2, 3]}>

                        <Panel key={1} header={t('General')}>
                          <Row>
                            <>
                              {
                                task.taskId === 0
                                  ?
                                  null
                                  :
                                  <>
                                    <Col span={24} className='stm-margin-bottom-16
                                                    stm-font-size-14
                                                    stm-line-height-20'>
                                      <Row>
                                        <Col span={6}>{t('#ID')}</Col>
                                        <Col span={18} className='stm-font-weight-bold'>{task.taskID}</Col>
                                      </Row>
                                    </Col>
                                    <Col span={24} className='stm-margin-bottom-16
                                                    stm-font-size-14
                                                    stm-line-height-20'>
                                      <Row>
                                        <Col span={6}>{t('Hierarchy')}</Col>
                                        <Col span={18} className='stm-font-weight-bold'>{task.parentName ? `${task.parentName} / ${task.taskName}` : task.taskName}</Col>
                                      </Row>
                                    </Col>
                                    <Col span={24} className='stm-margin-bottom-16
                                                    stm-font-size-14
                                                    stm-line-height-20'>
                                      <Row>
                                        <Col span={6}>{task.taskID === 0 ? t('Create this as Sub category?') : t('Type')}</Col>
                                        <Col span={18} className='stm-font-weight-bold'>
                                          {
                                            task.taskID === 0
                                              ?
                                              <>
                                                <Switch
                                                  checkedChildren={t('Yes')}
                                                  unCheckedChildren={t('No')}
                                                  checked={task.nextCount > 0}
                                                  onChange={(value) => this.props.CmsTaskStore.setnextCount(value)} />
                                              </>
                                              :
                                              task.parentID === 0 ? t('Root') : (task.parentID === 1 ? t('Menu') : (task.nextCount > 0 ? t('Category / Sub Category') : t('Item')))
                                          }
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col span={24} className='stm-margin-bottom-16
                                                    stm-font-size-14
                                                    stm-line-height-20'>
                                      <Row>
                                        <Col span={6}>{t('Task Name')} *</Col>
                                        <Col span={18} className=''>
                                          {
                                            task.parentID !== 0
                                              ?
                                              <>
                                                <Input
                                                  value={task.taskName}
                                                  onChange={(e) => this.props.CmsTaskStore.settaskName(e.target.value)}
                                                  className='stm-width-100-percent' />
                                                {
                                                  this.isValidTaskName()
                                                    ?
                                                    null
                                                    :
                                                    <div className='stm-color-error stm-padding-top-4'>* {t('Required')}</div>
                                                }
                                              </>
                                              :
                                              <span className='stm-font-weight-bold'>{task.taskName}</span>
                                          }
                                        </Col>
                                      </Row>
                                    </Col>
                                  </>
                              }
                            </>
                          </Row>
                        </Panel>

                        <Panel key={2} header={t('Name & Description')}>
                          <Row>
                            {
                              task.parentID !== 0
                                ?
                                <>
                                  <Col span={24} className='stm-margin-bottom-16
                                                            stm-font-size-14
                                                            stm-line-height-20'>
                                    <Row>
                                      <Col span={24} className='stm-margin-bottom-16'>{t('Name')}</Col>
                                      <>
                                        {
                                          activeLanguages.map(lang => {
                                            return (
                                              <Col key={lang.id} span={24} className='stm-margin-bottom-16
                                                                                      stm-font-size-14
                                                                                      stm-line-height-20
                                                                                      stm-padding-left-16'>
                                                <Row>
                                                  <Col span={6}>{lang.originalName} {defaultLanguageId === lang.id ? '*' : null}</Col>
                                                  <Col span={18} className=''>
                                                    {
                                                      task.parentID !== 0
                                                        ?
                                                        <>
                                                          <Input
                                                            value={task.taskLanguages.find(fi => fi.langID === lang.id).taskLangName}
                                                            onChange={(e) => this.props.CmsTaskStore.settaskLangName(lang.id, e.target.value)}
                                                            className='stm-width-100-percent' />
                                                          <>
                                                            {
                                                              defaultLanguageId === lang.id
                                                                ?
                                                                <>
                                                                  {
                                                                    this.isValidTaskNameEnglish()
                                                                      ?
                                                                      null
                                                                      :
                                                                      <div className='stm-color-error stm-padding-top-4'>* {t('Required')}</div>
                                                                  }
                                                                </>
                                                                :
                                                                null
                                                            }
                                                          </>
                                                        </>
                                                        :
                                                        task.taskName
                                                    }
                                                  </Col>
                                                </Row>
                                              </Col>
                                            )
                                          })
                                        }
                                      </>
                                    </Row>
                                  </Col>
                                  <Col span={24} className='stm-margin-bottom-16
                                                        stm-font-size-14
                                                        stm-line-height-20'>
                                    <Row>
                                      <Col span={24} className='stm-margin-bottom-16'>{t('Description')}</Col>
                                      <>
                                        {
                                          activeLanguages.map(lang => {
                                            return (
                                              <Col key={lang.id} span={24} className='stm-margin-bottom-16
                                                                                  stm-font-size-14
                                                                                  stm-line-height-20
                                                                                  stm-padding-left-16'>
                                                <Row>
                                                  <Col span={6}>{lang.originalName}</Col>
                                                  <Col span={18} className=''>
                                                    {
                                                      task.parentID !== 0
                                                        ?
                                                        <CKEditor
                                                          editor={ClassicEditor}
                                                          data={task.taskLanguages.find(fi => fi.langID === lang.id).taskLangDescription}
                                                          onChange={(event, editor) => {
                                                            const data = editor.getData();
                                                            this.props.CmsTaskStore.settaskLangDescription(lang.id, data)
                                                          }}
                                                        />
                                                        :
                                                        task.taskDesc
                                                    }
                                                  </Col>
                                                </Row>
                                              </Col>
                                            )
                                          })
                                        }
                                      </>
                                    </Row>
                                  </Col>
                                </>
                                :
                                <div>{t('No Detail')}</div>
                            }
                          </Row>
                        </Panel>

                        <Panel key={3} header={t('Configuration')}>
                          <Row>
                            <>
                              {
                                task.parentID !== 0
                                  ?
                                  <>
                                    <Col span={24} className='stm-margin-bottom-16
                                                        stm-font-size-14
                                                        stm-line-height-20'>
                                      <Row>
                                        <Col span={6} className='stm-margin-bottom-16'>{t('Sort')}</Col>
                                        <Col span={18} className=''>
                                          <InputNumber
                                            className='stm-width-100'
                                            value={task.sortID}
                                            onChange={(value) => this.props.CmsTaskStore.setsortID(value)}
                                            min={0}
                                          />
                                          <>
                                            {
                                              this.isValidSort()
                                                ?
                                                null
                                                :
                                                <div className='stm-color-error stm-padding-top-4'>* {t('Required')}</div>
                                            }
                                          </>
                                        </Col>
                                      </Row>
                                    </Col>
                                    <>
                                      {
                                        task.nextCount === 0
                                          ?
                                          <>
                                            <Col span={24} className='stm-margin-bottom-16
                                                        stm-font-size-14
                                                        stm-line-height-20'>
                                              <Row>
                                                <Col span={6} className='stm-margin-bottom-16'>{t('Original Price')}</Col>
                                                <Col span={18} className=''>
                                                  <InputNumber
                                                    className='stm-width-100'
                                                    value={task.price}
                                                    onChange={(value) => this.props.CmsTaskStore.setprice(value)}
                                                    min={0}
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                  />
                                                  <>
                                                    {
                                                      this.isValidPrice()
                                                        ?
                                                        null
                                                        :
                                                        <div className='stm-color-error stm-padding-top-4'>* {t('Required')}</div>
                                                    }
                                                  </>
                                                </Col>
                                              </Row>
                                            </Col>
                                            <Col span={24} className='stm-margin-bottom-16
                                                        stm-font-size-14
                                                        stm-line-height-20'>
                                              <Row>
                                                <Col span={6} className='stm-margin-bottom-16'>{t('If Item Has Stock?')}</Col>
                                                <Col span={18} className='stm-font-weight-bold'>
                                                  <Switch
                                                    checkedChildren={t('Yes')}
                                                    unCheckedChildren={t('No')}
                                                    checked={task.minimumStock > 0}
                                                    onChange={(value) => this.props.CmsTaskStore.setTaskHasMinimumStock(value)} />
                                                </Col>
                                              </Row>
                                            </Col>
                                            <Col span={24} className='stm-margin-bottom-16
                                                        stm-font-size-14
                                                        stm-line-height-20
                                                        stm-padding-left-16'>
                                              <Row>
                                                <Col span={6} className='stm-margin-bottom-16'>{t('Stock')}</Col>
                                                <Col span={18} className=''>
                                                  {
                                                    task.minimumStock > 0
                                                      ?
                                                      <>
                                                        <InputNumber
                                                          className='stm-width-100'
                                                          min={0}
                                                          value={task.total}
                                                          onChange={(value) => this.props.CmsTaskStore.settotal(value)} />
                                                        <>
                                                          {
                                                            this.isValidTotal()
                                                              ?
                                                              null
                                                              :
                                                              <div className='stm-color-error stm-padding-top-4'>* {t('Required')}</div>
                                                          }
                                                        </>
                                                      </>
                                                      :
                                                      <span className='stm-font-weight-bold'>{task.total}</span>
                                                  }
                                                </Col>
                                              </Row>
                                            </Col>
                                            <Col span={24} className='stm-margin-bottom-16
                                                        stm-font-size-14
                                                        stm-line-height-20
                                                        stm-padding-left-16'>
                                              <Row>
                                                <Col span={6} className='stm-margin-bottom-16'>{t('Minimum Stock')}</Col>
                                                <Col span={18} className=''>
                                                  {
                                                    task.minimumStock > 0
                                                      ?
                                                      <>
                                                        <InputNumber
                                                          className='stm-width-100'
                                                          min={0}
                                                          value={task.minimumStock}
                                                          onChange={(value) => this.props.CmsTaskStore.setminimumStock(value)} />
                                                        <>
                                                          {
                                                            this.isValidMinimumStock()
                                                              ?
                                                              null
                                                              :
                                                              <div className='stm-color-error stm-padding-top-4'>* {t('Required')}</div>
                                                          }
                                                        </>
                                                      </>
                                                      :
                                                      <span className='stm-font-weight-bold'>{task.minimumStock}</span>
                                                  }
                                                </Col>
                                              </Row>
                                            </Col>
                                            <Col span={24} className='stm-margin-bottom-16
                                                        stm-font-size-14
                                                        stm-line-height-20'>
                                              <Row>
                                                <Col span={6} className='stm-margin-bottom-16'>{t('Request Limit')}</Col>
                                                <Col span={18} className=''>
                                                  <InputNumber
                                                    className='stm-width-100'
                                                    value={task.requestLimit}
                                                    onChange={(value) => this.props.CmsTaskStore.setrequestLimit(value)}
                                                    min={0}
                                                    max={100}
                                                  />
                                                  <>
                                                    {
                                                      this.isValidRequestLimit()
                                                        ?
                                                        null
                                                        :
                                                        <div className='stm-color-error stm-padding-top-4'>* {t('Required')}</div>
                                                    }
                                                  </>
                                                </Col>
                                              </Row>
                                            </Col>
                                            <Col span={24} className='stm-margin-bottom-16
                                                        stm-font-size-14
                                                        stm-line-height-20'>
                                              <Row>
                                                <Col span={6} className='stm-margin-bottom-16'>{t('Daily Request Limit')}</Col>
                                                <Col span={18} className=''>
                                                  <InputNumber
                                                    className='stm-width-100'
                                                    value={task.dailyRequestLimit}
                                                    onChange={(value) => this.props.CmsTaskStore.setdailyRequestLimit(value)}
                                                    min={0}
                                                    max={100}
                                                  />
                                                  <>
                                                    {
                                                      this.isValidDailyRequestLimit()
                                                        ?
                                                        null
                                                        :
                                                        <div className='stm-color-error stm-padding-top-4'>* {t('Required')}</div>
                                                    }
                                                  </>
                                                </Col>
                                              </Row>
                                            </Col>
                                          </>
                                          :
                                          <>
                                            <Col span={24} className='stm-margin-bottom-16
                                                        stm-font-size-14
                                                        stm-line-height-20'>
                                              <Row>
                                                <Col span={6} className='stm-margin-bottom-16'>{t('Start Time')}</Col>
                                                <Col span={18} className='stm-font-weight-bold'>
                                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardTimePicker
                                                      margin='dense'
                                                      ampm={false}
                                                      id='itemstarttime-picker'
                                                      style={{ width: '30%', marginRight: 5, marginLeft: 5, top: -12 }}
                                                      value={task.startTimeDate}
                                                      onChange={(value) => this.props.CmsTaskStore.setstartTimeDate(value)}
                                                      KeyboardButtonProps={{
                                                        'aria-label': t('change time'),
                                                      }}
                                                    />
                                                  </MuiPickersUtilsProvider>
                                                </Col>
                                              </Row>
                                            </Col>
                                            <Col span={24} className='stm-margin-bottom-16
                                                        stm-font-size-14
                                                        stm-line-height-20'>
                                              <Row>
                                                <Col span={6} className='stm-margin-bottom-16'>{t('End Time')}</Col>
                                                <Col span={18} className='stm-font-weight-bold'>
                                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardTimePicker
                                                      margin='dense'
                                                      ampm={false}
                                                      id='itemstarttime-picker'
                                                      style={{ width: '30%', marginRight: 5, marginLeft: 5, top: -12 }}
                                                      value={task.endTimeDate}
                                                      onChange={(value) => this.props.CmsTaskStore.setendTimeDate(value)}
                                                      KeyboardButtonProps={{
                                                        'aria-label': t('change time'),
                                                      }}
                                                    />
                                                  </MuiPickersUtilsProvider>
                                                </Col>
                                              </Row>
                                            </Col>
                                          </>
                                      }
                                    </>
                                    <>
                                      {
                                        task.parentID !== 1
                                          ?
                                          <Col span={24} className='stm-margin-bottom-16
                                                stm-font-size-14
                                                stm-line-height-20'>
                                            <Row>
                                              <Col span={6} className='stm-margin-bottom-16'>{t('Icon (Max Size 1MB)')}</Col>
                                              <Col span={6} className='stm-font-weight-bold'>
                                                <Upload
                                                  listType='picture-card'
                                                  className='avatar-uploader stm-min-width-100'
                                                  showUploadList={false}
                                                  customRequest={this.dummyRequest}
                                                  beforeUpload={this.beforeUploadIconImage}
                                                  onChange={(info) => this.uploadChangeIconImage(info, 'MenuIcon')}
                                                >
                                                  {
                                                    task.imageUrl && task.imageUrl !== ''
                                                      ?
                                                      <img src={task.imageUrl} alt='avatar' className='stm-height-32 stm-width-auto' />
                                                      :
                                                      <div>
                                                        <Icon style={{ color: '#32323F' }} type={this.state.uploadingIconImage ? 'loading' : 'plus'} />
                                                        <div className='stm-font-size-14 stm-line-height-18 stm-color-495057'>{t('Upload')}</div>
                                                      </div>
                                                  }
                                                </Upload>
                                                {
                                                  task.imageUrl && task.imageUrl !== '' ?
                                                    <div>
                                                      <Button onClick={() => this.props.CmsTaskStore.setimageUrl('')}>{t('Delete Image')}</Button>
                                                    </div>
                                                    : null
                                                }
                                              </Col>
                                            </Row>
                                          </Col>
                                          :
                                          null
                                      }
                                    </>
                                  </>
                                  :
                                  <div>{t('No Configuration')}</div>
                              }
                            </>
                          </Row>
                        </Panel>

                      </Collapse>

                      <div className='stm-margin-top-16'>
                        <>
                          {
                            task.parentID !== 0
                              ?
                              (
                                task.taskID !== 0
                                  ?
                                  <>
                                    <Row>
                                      <Col span={12}>
                                        <Button
                                          type='primary'
                                          onClick={this.update}
                                          disabled={!showEditButton}
                                          style={{ marginRight: 10 }}>{t('Update')}</Button>
                                        <Button
                                          type='default'
                                          onClick={() => this.props.CmsTaskStore.getByTaskId(task.taskID)}
                                          style={{ marginRight: 10 }}>{t('Cancel')}</Button>
                                      </Col>
                                      <Col span={12} className='stm-text-align-right'>
                                        <Button
                                          type='danger'
                                          onClick={this.delete}
                                          style={{ marginRight: 10 }}>{t('Delete')}</Button>
                                      </Col>
                                    </Row>
                                  </>
                                  :
                                  <>
                                    <Button
                                      type='primary'
                                      onClick={this.create}
                                      disabled={!showEditButton}
                                      style={{ marginRight: 10 }}>{t('Create')}</Button>
                                    <Button
                                      type='default'
                                      onClick={() => this.props.CmsTaskStore.getByTaskId(task.parentID)}
                                      style={{ marginRight: 10 }}>{t('Cancel')}</Button>
                                  </>
                              )
                              :
                              null
                          }
                        </>
                      </div>
                    </Form>
                    :
                    <div>
                    </div>
                }
              </>
            </Card>
          </Grid>
        </Grid>
      </MainContainer>
    )
  }
}

export default withTranslation(undefined, { i18n: adminI18n })(CmsTask);